module.exports = {
  common: {
    save: 'Сохранить',
    cancel: 'Отмена',
    combinationTitle: 'Правила автоматического выпуска документов (комбинация)',
    ruleTitle: 'Правила автоматического выпуска документов',
    AutomaticOrderReleaseTriggerSettings: 'Настройки триггера автоматического выпуска документов',
    ReleaseGuaranteeSetting: 'Настройки гарантии выпуска документов',
    docType: 'Тип коносамента',
    customerSelfRelease: 'Тип HBL',
    releaseType: 'Способ оформления коносамента',
    cargoSource: 'Источник груза',
    creditObject: 'Объект кредитного контроля выпуска документов',
    receivableType: 'Тип доходов и расходов',
    creditLimitedDate: 'Кредитный период',
    creditLimitAmount: 'Кредитный лимит',
    customerType: 'Тип доверительной организации'
  },
  selectBranch: 'Выберите филиал:',
  ApplyTheHeadOfficeConfiguration: 'Применить конфигурацию головной компании',
  enterRuleName: 'Введите название правила',
  add: 'Добавить',
  edit: 'Редактировать',
  deletes: 'Удалить',
  refresh: 'Обновить',
  ruleName: 'Название правила автоматического выпуска документов',
  businessTypes: 'Применимые типы операций',
  conversionRules: 'Связанные правила обработки',
  ruleDescription: 'Описание',
  orderNum: 'Порядковый номер',
  ruleGroupName: 'Название комбинации правил автоматического выпуска документов',
  ruleNames: 'Включенные названия правил',
  performActions: 'Включенные действия',
  officeCode: 'Филиал',
  customerCompany: 'Применимые клиенты',
  refreshSuccess: 'Обновление успешно',
  operationSuccess: 'Операция успешна',
  dialogRuleName: 'Название правила (комбинации)',
  RuleNamePlaceholder: 'Введите название правила',
  ruleDescriptionPlaceholder: 'Содержание описания',
  AnyRuleTitle: 'Применить любое из следующих правил',
  AllRuleTitle: 'Применить все следующие правила',
  PerformRelatedActions: 'Выполнить связанные действия',
  meetConditions: 'Условие выполнено',
  meetConditionsRemind: 'Автоматический выпуск документов при выполнении условий. (Статус обновляется на "Готов к выпуску")',
  dissatisfaction: 'Условие не выполнено',
  runningRules: 'Запустить следующую комбинацию правил',
  runningRulesRemind: 'Документы не выпускаются при невыполнении условий. (Статус обновляется на "Ожидание оплаты")',
  remark1: 'Примечание: если для всех комбинаций "Условие не выполнено" выбрано "Запустить следующую комбинацию правил", а фактический результат проверки всех комбинаций - невыполнение условий.',
  remark2: 'Статус выпуска документов также обновится на "Ожидание оплаты"',
  applicableCustomers: 'Применимые клиенты',
  applicableCustomersRemind1: 'Автоматический выпуск документов применяется только к клиентам с типом расчетов "Не по счету"',
  applicableCustomersRemind2: '(т.е. клиенты с кредитным периодом)',
  conditionType: 'Тип условия',
  customerName: 'Наименование клиента',
  branchOffice: 'Филиал',
  successRemind: 'Сохранено успешно',
  toggleReminder: 'Пожалуйста, подтвердите смену применимых клиентов на «Все»? Это действие очистит список клиентов ниже.',
  tips: 'Подсказка',
  yes: 'Да',
  no: 'Нет',
  deleteRemind: 'Выберите хотя бы одну запись для удаления!',
  ruleName1: 'Название правила',
  meetAnyConditions: 'Выполнение любого из условий',
  meetAllConditions: 'Выполнение всех условий',
  processingRules: 'Правила обработки выпуска документов',
  releaseDemand: 'Выпуск документов после оплаты',
  prompt: 'Перед сохранением заполните информацию ${prompt}.',
  Tips1: 'Заполните информацию о правилах',
  equal: 'Равно',
  neq: 'Не равно',
  exceed: 'Превышает',
  notMore: 'Не превышает',
  SC: 'Собственный груз',
  NC: 'Указанный груз',
  creditUsedLimitAmount: 'Использованный лимит',
  customerIssuing: 'Самостоятельное оформление клиентом',
  issuedCompany: 'Самостоятельное оформление компанией',
  original: 'Оригинал',
  telexRelease: 'Телекс-релиз',
  accountingPeriod: 'Установка кредитного периода',
  client: 'Доверитель',
  agent: 'Агент указанного груза',
  settlement: 'Объект расчёта',
  collection: 'Получение платежа',
  maintenanceName: 'Название комбинированного правила',
  rule: 'Правило',
  whole: 'Все',
  TriggerTheNode: 'Триггер',
  ScheduledPollingTriggersAutomaticOrderVerification: 'Автоматическая проверка выпуска по расписанию',
  ApplyBranchOfficeSettings: 'Настройки филиала',
  automatic: 'Автоматически',
  daily: 'Ежедневно',
  blacklist: 'Чёрный список',
  EffectiveList: 'Действующий список',
  ChargeRecordState: 'Оценка состояния учета расходов',
  ChargeRecordState0: 'Должна содержать дебиторскую задолженность.',
  ChargeRecordState1: 'Должны содержать расходы, подлежащие расчету в качестве доверительной единицы, независимо от получения и оплаты',
  ChargeRecordState2: 'Независимо от стоимости',
  SettlementBillMode: 'См. модель размещения',
  SettlementBillCheckCost: 'При отсутствии другой дебиторской задолженности учитывается кредиторская задолженность перед принципалом, которая считается оплаченной по векселю',
  SettlementBillCustomer: 'Списана только дебиторская задолженность по доверенности',
  SettlementBillCustomerCheckCost: 'В случае дебиторской задолженности, причитающейся с неподтвержденной организации, учитывается кредиторская задолженность перед доверенной организацией, которая считается оплаченной доверенной организацией',
  CreditObjectMode: 'Режим управления информацией'
}
